export const SITE_NAME = "LOINC";
